import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { Grid, Typography, Theme, Link, useMediaQuery } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import DefaultLayout from '@src/components/DefaultLayout'
import { FormattedMessage } from 'react-intl'
import { AnalyticsDispType } from '@src/types/graphql-types'
import ProductSearchForm from './ProductSearchForm'
import RecentlyViewedProductsCarousel from '@src/components/RecentlyViewedProductsCarousel/RecentlyViewedProductsCarousel'
import DocumentLibraryBanner from '../DocumentSearch/DocumentLibraryBanner'
import { documentsSearch } from '@src/routes'

export const useStyles = makeStyles((theme: Theme) => {
  return {
    body: {
      padding: theme.spacing(8, 0, 10),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(10, 0, 12),
      },
    },
    title: {
      marginBottom: theme.spacing(4),
    },
    container: {
      padding: theme.spacing(0, 4),
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(0, 14),
      },
    },
    productSdsContainer: {
      [theme.breakpoints.up('md')]: {
        height: '100%',
        paddingRight: theme.spacing(10),
      },
    },
    recentlyViewedProducts: {
      marginTop: theme.spacing(12),
    },
    medium: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    bannerContainer: {
      paddingTop: theme.spacing(14),
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'flex-end',
    },
  }
})

const AdvancedSearch = () => {
  const classes = useStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <DefaultLayout className={classes.body}>
      <Container maxWidth="lg" className={classes.container}>
        <Grid item xs={12} md={12} lg={6} justifyContent="flex-end">
          <div className={classes.productSdsContainer}>
            <>
              <Typography
                id="advanced-search-title"
                variant="h1"
                className={classes.title}
              >
                <FormattedMessage
                  id="ADVANCED_SEARCH"
                  defaultMessage="Advanced Search"
                />
              </Typography>
              <ProductSearchForm />
            </>
          </div>
        </Grid>

        {!isMobile && (
          <Grid item xs={12} md={12} lg={6} className={classes.bannerContainer}>
            <DocumentLibraryBanner>
              <Typography variant="body1">
                <FormattedMessage
                  id="DOC_OR_CERT"
                  defaultMessage="Looking for a <strong>document</strong> or <strong>certificate</strong>?"
                  values={{
                    strong: (...chunks) => <strong>{chunks}</strong>,
                  }}
                />
              </Typography>
              <Typography variant="body1">
                <span className={classes.medium}>
                  <FormattedMessage id="TRY" defaultMessage="Try" />
                </span>{' '}
                <Link href={documentsSearch.index()}>
                  <FormattedMessage id="DOCUMENTS" defaultMessage="Documents" />
                </Link>{' '}
                <span className={classes.medium}>
                  <FormattedMessage id="INSTEAD" defaultMessage="instead" />
                </span>
                {'.'}
              </Typography>
            </DocumentLibraryBanner>
          </Grid>
        )}
      </Container>
      <RecentlyViewedProductsCarousel
        dispType={AnalyticsDispType.RecentlyViewedAdvancedSearch}
        className={classes.recentlyViewedProducts}
        parentPageName="advanced search"
        parentPageNameDetail="advanced search page"
      />
    </DefaultLayout>
  )
}

export default AdvancedSearch
